<template>
  <el-table
      :data="tableData"
      @selection-change="handleSelectionChange"
  >

    <el-table-column type="index" width="50"></el-table-column>

    <el-table-column prop="subBrandNumber" :label="$t('lang.子品牌编号')"></el-table-column>
    <el-table-column prop="subBrandName" :label="$t('lang.子品牌名称')"></el-table-column>
    <el-table-column prop="productSubModel" :label="$t('lang.适配型号')"></el-table-column>
    <el-table-column prop="createTimeStr" :label="$t('lang.创建时间')"></el-table-column>
    <el-table-column prop="applyTimeStr" :label="$t('lang.申请时间')"></el-table-column>



    <el-table-column fixed="right" :label="$t('lang.操作')" width="240">
      <template slot-scope="scope">
        <el-button size="mini" @click='$router.push({path: "/apk-detail",query: {code: scope.row.code} });' plain  type="primary">{{$t('lang.查看')}}</el-button>
        <el-button size="mini" @click='handleDownload(scope.row)' plain  type="primary">{{$t('lang.下载')}}</el-button>
        <el-button size="mini" plain type="success" @click="handleRecall(scope.row)">{{$t('lang.撤回')}}</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import {downloadFile} from "../../js/common";

export default {
  name: "AuditTable",
  props: {
    tableData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
    }
  },
  methods: {
    handleSelectionChange(selection) {
      this.$emit('selection-change', selection)
    },

    handleDownload(row) {
      if(row.fileCode) {
        downloadFile(this,row.fileCode)
      } else {
        this.$message.error(this.$t('lang.该APK还没审批通过'))
      }
    },

    handleRecall(row) {
      this.$emit('recall', row);
    }
  }
}
</script>

<style scoped>

</style>
